import { useEffect, useMemo } from 'react';
import { Amplify } from 'aws-amplify';
import { getService, Services } from '@innovyze/lib_get_service';
import { getApiEnvironment, getRegionName } from '../utils';
import { generateClient } from 'aws-amplify/api';

export const useAmplifyClient = (serviceName: Services) => {
	useEffect(() => {
		const setupAmplify = () => {
			const endpoint = getService(serviceName, {}, getApiEnvironment());
			const region = getRegionName();

			Amplify.configure({
				API: {
					GraphQL: {
						endpoint,
						region,
						defaultAuthMode: 'lambda',
					},
				},
			});
		};

		setupAmplify();
	}, [serviceName]);

	const client = useMemo(() => generateClient(), []);

	return client;
};
